import { MultiSelectChoiceEdit } from '@powerportalspro/react-fluent';

export function MultiSelectChoiceEditMainSample() {
  return <MultiSelectChoiceEdit columnName="ppp_favoritecolors" />;
}
